import classnames from "classnames";
import { RichText } from "prismic-reactjs";
import React, { useState } from "react";
import { IPrimary } from "src/types/prismic";
import styled from "styled-components";

import { Icon } from "..";

interface IWrapper {
  color?: string;
  background?: string;
}

const Wrapper = styled.div<IWrapper>`
  && {
    padding: 25px 15px;
    background: ${({ background }: IWrapper): string =>
      background || "inherit"};
    color: ${({ color }: IWrapper): string => color || "#000"};
  }

  p {
    margin: 15px 0;
  }

  img {
    margin: auto;
  }
`;

const CollapseContent = styled.div``;

interface IExpandContent {
  isVisible?: boolean;
}
const ExpandContent = styled.div<IExpandContent>`
  display: ${({ isVisible }: IExpandContent): string =>
    isVisible || isVisible === undefined ? "block" : "none"};
`;

interface IToggleButton {
  color?: string;
}

const ToggleButton = styled.button<IToggleButton>`
  && {
    margin-top: 25px;
    border: 1px solid ${({ color }: IWrapper): string => color || "transparent"};
    background: transparent;
  }
  i {
    color: ${({ color }: IWrapper): string => color || "white"};
  }
`;

interface IProps {
  className?: string;
  data: IPrimary;
}

const Collapse = ({ className, data }: IProps): JSX.Element | null => {
  const {
    button_more,
    button_less,
    classnames: collapseClassnames,
    collapse_content,
    expand_content,
    expand_is_lazy,
    color,
    background_color,
  } = data;

  // tslint:disable-next-line: no-console

  const [open, setOpen] = useState<boolean>(false);

  return (
    <Wrapper
      className={classnames(className, collapseClassnames)}
      color={color}
      background={background_color}
    >
      <CollapseContent>
        <RichText render={collapse_content} />
      </CollapseContent>

      {open && expand_is_lazy && (
        <ExpandContent>
          <RichText render={expand_content} />
        </ExpandContent>
      )}

      {!expand_is_lazy && (
        <ExpandContent isVisible={open}>
          <RichText render={expand_content} />
        </ExpandContent>
      )}

      <ToggleButton
        className="toggle-collapse"
        onClick={(): void => setOpen((current) => !current)}
        color={color}
      >
        {open ? (
          button_less?.url ? (
            <img src={button_less.url} alt={button_less.alt} />
          ) : (
            <Icon name="moins" size={24} />
          )
        ) : button_more?.url ? (
          <img src={button_more.url} alt={button_more.alt} />
        ) : (
          <Icon name="plus" size={24} />
        )}
      </ToggleButton>
    </Wrapper>
  );
};

export default Collapse;
